// Author liang gang qiang
// Date 2023-10-18 11:08:01

class SithMomMainProjectTemplate {
constructor({
        id = null,
        headId = '',
        parentId = '',
        wbsLevel = '',
        seq = '',
        type = '',
        activityId = '',
        taskName = '',
        chineseDescription = '',
        duration = '',
        predecessor = '',
        autoCalculate = '',
        milestoneCode = '',
        resource = '',
        isHead = '',
        activate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.headId = headId;
    this.parentId = parentId;
    this.wbsLevel = wbsLevel;
    this.seq = seq;
    this.type = type;
    this.activityId = activityId;
    this.taskName = taskName;
    this.chineseDescription = chineseDescription;
    this.duration = duration;
    this.predecessor = predecessor;
    this.autoCalculate = autoCalculate;
    this.milestoneCode = milestoneCode;
    this.resource = resource;
    this.isHead = isHead;
    this.activate = activate;
    this.remark = remark;
}
}

function newEntity() {
return new SithMomMainProjectTemplate();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'parentId',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsLevel',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.wbsLevel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'seq',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.type',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activityId',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.activityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'taskName',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.taskName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'chineseDescription',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.chineseDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'duration',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.duration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'predecessor',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.predecessor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'autoCalculate',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.autoCalculate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'milestoneCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.milestoneCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'resource',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.resource',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activate',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.activate',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    headIdFilter : '',
    parentIdFilter : '',
    wbsLevelFilter : '',
    seqFilter : '',
    typeFilter : '',
    activityIdFilter : '',
    taskNameFilter : '',
    chineseDescriptionFilter : '',
    durationFilter : '',
    predecessorFilter : '',
    autoCalculateFilter : '',
    milestoneCodeFilter : '',
    resourceFilter : '',
    isHeadFilter : '',
    activateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'wbsLevelFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.wbsLevel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.type',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activityIdFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.activityId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taskNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.taskName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'chineseDescriptionFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.chineseDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'durationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.duration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'predecessorFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.predecessor',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'autoCalculateFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.autoCalculate',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'milestoneCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.milestoneCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'resourceFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.filter.resource',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'headId',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.headId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentId',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsLevel',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.wbsLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activityId',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.activityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'taskName',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.taskName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'chineseDescription',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.chineseDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'duration',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.duration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'predecessor',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.predecessor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'autoCalculate',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.autoCalculate',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'milestoneCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.milestoneCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'resource',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.resource',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isHead',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.isHead',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activate',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.activate',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectTemplate.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMainProjectTemplate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
